module.exports = {"colors":{"concrete":"#D7D9E0","offWhite":"#F5F5F5","cloud":"#F0F1F5","asphalt":"#3f4c5a","white":"#fff","blue":"#60B2D0","red":"#e04247","brGreen":"#438774","copilotBlue":"#28a4bd"},"screens":{"mobile":"500px","tablet":"769px","desk":"1024px","big":"1600px","huge":"1920px"},"space":{"baseSpace":1,"room":"1em"},"fonts":{"normal":"'Fakt Pro Nor', sans-serif","italic":"'Fakt Pro Nor Ita', sans-serif","bold":"'Fakt Pro SmBd', sans-serif"}}


//////////////////
// WEBPACK FOOTER
// ./src/styles/vars.json
// module id = ./src/styles/vars.json
// module chunks = 168707334958949